import styled from "styled-components";
import Calendar from "../../../organisms/Calendar";

export const StyledCalendar = styled(Calendar)`
  width: 100%;
  border-radius: 5px;
  padding: 0%;
`;
